/* mazo-trust.js: turns the trust line "Delivered within N working days." into a real date (TASKS T117, owner
   2026-10-11: show "Arrives by 18 Oct" instead of "within 7 days"). 2026-10-11 15:40 (owner): wording "Delivered by". 2026-10-12 (owner): the date joins the bold line.
   N comes from the snippet (data-mazo-arrives = handling max + transit max from Theme settings > Store terms), so the
   promise never drifts from the policy. Working days skip Sundays only (couriers deliver Monday to Saturday); public
   holidays are not known here, which is why the date uses the slowest case (handling max + transit max) and is a
   promise of "by", not "on". Runs once on load and again whenever Dawn re-renders the product section.
   Loaded from sections/main-product.liquid. No dependencies.
   2026-10-15 (Jig Jig, made to order): `data-mazo-calendar` counts calendar days instead of working days (the owner's
   20 days are order to doorstep) and `data-mazo-prefix` replaces the joining words (", delivered by "). */
(function () {
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addWorkingDays(start, n) {
    var d = new Date(start.getTime());
    var left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) left -= 1;          // Sunday does not count
    }
    return d;
  }

  function apply(root) {
    (root || document).querySelectorAll('[data-mazo-arrives]:not([data-mazo-arrives-set])').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-mazo-arrives'), 10);
      if (!n || n < 1 || n > 90) return;         // bad setting: keep the server text
      var d;
      if (el.hasAttribute('data-mazo-calendar')) { d = new Date(); d.setDate(d.getDate() + n); }
      else d = addWorkingDays(new Date(), n);
      var pre = el.getAttribute('data-mazo-prefix') || ' and delivery by ';
      el.setAttribute('data-mazo-arrives-set', '');   // set once; the text change below must not re-trigger
      // 2026-10-12 (owner: "Free shipping and delivery by <day, date>"): the span sits inside the bold line and
      // finishes it, e.g. "Free shipping" + " and delivery by Mon, 19 Oct".
      el.textContent = pre + DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); });
  else apply();
  // Dawn swaps the product info HTML on variant changes; re-apply after each swap
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { apply(); break; }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
